import React from 'react'
import './Leds.css'
import { PiDotOutlineFill } from 'react-icons/pi';
import { IoMdHeart } from 'react-icons/io';

export default function Leds({initFav=false, showValid=false, isError}) {  
  const dotBlack  = <PiDotOutlineFill color='#010101'/>;
  const dotGreen  = <PiDotOutlineFill color='#05c505'/>; 
  const heartBeat = <IoMdHeart className='heartBeat' color='#ff0000'/>;
  
  const iconDefault = dotBlack;
  const iconFavorite = dotGreen;
  const iconError = heartBeat;  
  const ledIcon = isError ? iconError : initFav ? iconFavorite : showValid ? iconDefault : '';
  
  return (
    <div className='leds'>
      {ledIcon}
    </div>
  )
}

// const SQR_RED = <TbSquareDot color='red'/>;
// const SQR_BLACK = <TbSquareDot color='#000'/>;
// const SQR_MID = <VscPrimitiveSquare />;
// const SQR_SMALL_BLACK = <GoSquare color='black'/>;
// const SQR_SMALL_BLUE = <GoSquare color='blue'/>;
// const SQR_SMALL_RED = <GoSquare color='red'/>;
// const SQR_SMALL_FILL = <GoSquareFill />;
// const HEART =     <IoMdHeart color='#f84'/>;
// const DOT_BLUE = <PiDotOutlineFill color='#0505ff'/>;
// const dotBeat = <PiDotOutlineFill className='heartBeat' color='#ff0000'/>;